module.exports = __webpack_public_path__ + "img/logo.9acf25c8.png";